import { RootStore } from "./rootStore";
import { observable, action, reaction } from "mobx";

export default class CommonStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;

    reaction(
      () => this.token,
      (token) => {
        if (token) {
          window.localStorage.setItem("jwt", token);
        } else {
          window.localStorage.removeItem("jwt");
        }
      }
    );
    reaction(
      () => this.usernameDisplay,
      (usernameDisplay) => {
        if (usernameDisplay) {
          window.localStorage.setItem("jwtuser", usernameDisplay);
        } else {
          window.localStorage.removeItem("jwtuser");
        }
      }
    );
  }

  @observable token: string | null = window.localStorage.getItem("jwt");
  @observable appLoaded = false;
  @observable usernameDisplay: string | null = window.localStorage.getItem(
    "jwtuser"
  );

  @action setToken = (token: string | null) => {
    this.token = token;
  };

  @action setUsername = (userDisplayName: string | null) => {
    this.usernameDisplay = userDisplayName;
  };

  @action setAppLoaded = () => {
    this.appLoaded = true;
  };
}
